import React, { useState, useEffect } from 'react';

import IconOnlyButton from './IconOnlyButton';

type CopyToClipboardButtonProps = {
  textToCopy: string;
};

const CopyToClipboardButton = ({ textToCopy }: CopyToClipboardButtonProps) => {
  const [copied, setCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(
    () => () => {
      // Clear timeout on unmount
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    },
    [timeoutId]
  );

  return copied ? (
    <p className='t-paragraph--small'>Copied to clipboard!</p>
  ) : (
    <IconOnlyButton
      sIcon='copy'
      sAriaLabel='Copy to clipboard'
      fnHandleClick={() => {
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);

        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        const newTimeoutId = setTimeout(() => setCopied(false), 2000); // Reset state after 2 seconds
        setTimeoutId(newTimeoutId);
      }}
    />
  );
};

export default CopyToClipboardButton;
